"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const lucide_vue_next_1 = require("lucide-vue-next");
const ConfigModal_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/UI/Modals/ConfigModal.vue"));
const sleep_1 = __importDefault(require("@common/tsutils/sleep"));
const Configuration_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/models/Configuration"));
let ConfigurationVue = class ConfigurationVue extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.loadedList = false;
        this.configurations = [];
        this.triggerTheModal = false;
    }
    saveConfig() {
        if (this.heatmap.empty())
            return;
        this.triggerTheModal = true;
    }
    closeModal() {
        this.triggerTheModal = false;
        this.load();
    }
    expand() {
        this.$emit('onexpandconfig', this.options.expanded);
    }
    onChangeExpand() {
        if (!this.options.expanded)
            return;
        this.load();
    }
    async load() {
        this.loadedList = false;
        this.configurations = await Configuration_1.default.loadList();
        await (0, sleep_1.default)(1000);
        this.loadedList = true;
    }
    async loadConfig(configuration) {
        await this.heatmap.fromConfiguration(configuration);
        this.$emit('onexpandconfig', true);
    }
    async deleteConfig(configuration) {
        this.loadedList = false;
        await configuration.delete();
        await this.load();
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ConfigurationVue.prototype, "heatmap", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ConfigurationVue.prototype, "options", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('options.expanded')
], ConfigurationVue.prototype, "onChangeExpand", null);
ConfigurationVue = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Settings: lucide_vue_next_1.Settings,
            ArrowRight: lucide_vue_next_1.ArrowRight,
            ModalConfig: ConfigModal_vue_1.default,
            Trash: lucide_vue_next_1.Trash,
        }
    })
], ConfigurationVue);
exports.default = ConfigurationVue;
